module.exports = __webpack_public_path__ + "static/media/company-home-07.4ac55c3a.png";